import { Container, Typography, Box, Button, TextField, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import useSWR from 'swr';
import { PATH_NAME } from '../../../configs/pathName';
import { generalFetcher } from "../../../helpers/Fetchers/fetchers";
import assets from "../../../assets";
import { deletePaymentMethods } from "../../../api/WalletAPI";
import { useState } from "react";
import colorConfigs from "../../../configs/colorConfigs";
import { typo } from "../../../assets/fonts/font";

const CardDetailsPage = () => {
  const { cardId } = useParams();
  const [open, setOpen] = useState(false);
  const { data: paymentMethods, error } = useSWR(PATH_NAME.API_GET_MY_PAYMENT_METHODS, generalFetcher);
  const navigate = useNavigate();

  // const { data: basicUserInfo } = useSWR(PATH_NAME.API_AUTH_PROFILE, generalFetcher);

  // const { data: paymentMethods, error } = useSWR(
  //   basicUserInfo ? PATH_NAME.API_GET_MY_PAYMENT_METHODS : null,
  //   generalFetcher
  // );

  if (error) return <div>Error loading card details</div>;
  if (!paymentMethods) return <div>Loading card details...</div>;

  const cardDetails = paymentMethods.find((card: any) => card.id === Number(cardId));

  const handleUnlinkCard = async () => {
    try {
      await deletePaymentMethods(cardId!);
      setOpen(false);
      navigate(PATH_NAME.MEMBER);
    } catch (error) {
      console.error("Error unlinking the card:", error);
    }
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };


  return (
    <Container sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '20px' , padding:0}}>
      <Box
        sx={{
          width: '320px',
          height: '180px',
          background: colorConfigs.primary,
          borderRadius: '15px',
          padding: '20px',
          color: colorConfigs.mainbody,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
        }}
      >
        <Typography variant="body1" sx={{ fontWeight: 'bold', letterSpacing: '1.5px', ...typo.bodyContent, color:colorConfigs.mainbody }}>
          **** **** **** {cardDetails.card_last_four}
        </Typography>
        <Box sx={{display:'flex', justifyContent:'space-between', alignItems:'flex-end'}}>
          <Typography variant="body2" sx={{ opacity: 0.8, ...typo.bodyContent, color:colorConfigs.mainbody }}>
            {/* {cardDetails.expiry_date ? cardDetails.expiry_date : 'No Expiry Date'} */}
          </Typography>
          <img src={assets.images.logo} alt="Logo" style={{ height: '20px' }} />
        </Box>
      </Box>

      <Box sx={{ marginTop: '30px' ,width: '320px'}}>
        <TextField
          fullWidth
          disabled
          label="Card Number"
          value={`**** **** **** ${cardDetails.card_last_four}`}
          sx={{ marginBottom: '15px' }}
          InputProps={{ sx: { input: { ...typo.bodyContent, }, }, }}
          InputLabelProps={{ sx: { ...typo.bodyContent, }, }}
        />
        <TextField
          fullWidth
          disabled
          label="Card Type"
          value={cardDetails.card_type || "Not Available"}
          sx={{ marginBottom: '15px' }}
          InputProps={{ sx: { input: { ...typo.bodyContent, }, }, }}
          InputLabelProps={{ sx: { ...typo.bodyContent, }, }}
        />
      </Box>

      <Button
        variant="contained"
        sx={{
          marginTop: '20px',
          width: '320px',
          padding: '12px 0',
          background:colorConfigs.primary,
          fontWeight: 'bold',
          textTransform: 'none',
          borderRadius: '8px',
          '&:hover': {
          background: colorConfigs.primary,
          }, ...typo.bodyContent , color:colorConfigs.mainbody
        }}
        onClick={handleClickOpen}
      >
        Unlink Card
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
      >
        <DialogTitle sx={{...typo.title}} >{"Unlink Card"}</DialogTitle>
        <DialogContent>
          <DialogContentText sx={{...typo.bodyContent}}>
            Are you sure you want to unlink this card?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary"
          sx={{
            background:colorConfigs.secondary,
            '&:hover': {
            background: colorConfigs.secondary,
            }, ...typo.bodyContent ,
          }}>
            Cancel
          </Button>
          <Button onClick={handleUnlinkCard} color="secondary" variant="contained" 
            sx={{
            background:colorConfigs.primary,
            '&:hover': {
            background: colorConfigs.primary,
            }, ...typo.bodyContent , color:colorConfigs.mainbody
          }}>
            Unlink
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default CardDetailsPage;